import React from "react";

export function Gap5() {
    return <div className="gap" style={{ width: 5, height: 5 }} />;
}

export function Gap10() {
    return <div className="gap" style={{ width: 10, height: 10 }} />;
}

export function Gap20() {
    return <div className="gap" style={{ width: 20, height: 20 }} />;
}

export function Gap30() {
    return <div className="gap" style={{ width: 30, height: 30 }} />;
}

export function Gap(props) {
    return (
        <div
            className="gap"
            style={{ width: props.size, height: props.size }}
        />
    );
}

export function FlexSpacer() {
    return <div style={{ flexGrow: 2 }}></div>;
}
